import { useEffect, ChangeEvent, useState } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';

import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';
import { useUtils } from '../hooks/useUtils';

import { useLoader } from "../hooks/useLoader";
import { useAuth } from "../hooks/useAuth";
import { useGetRequestDetailsByID } from "../hooks/Request/useGetRequestDetailsByID";
import { useGetItemsByRequestID } from '../hooks/RequestItems/useGetItemsByRequestID';

import Comments from "../components/Comments/Comments";

import ViewMembersField from "../components/ViewFields/ViewMembersField";
import ViewTextField from "../components/ViewFields/ViewTextField";
import ViewItemField from "../components/ViewFields/ViewItemField";
import {Modal, Button, Label, Textarea } from "flowbite-react";

import CustomThemeModal from "../components/CustomThemes/CustomThemeModal";
import StatusLabel from '../components/UtilityHelpers/StatusLabel';

import { IoMdCheckmarkCircle } from "react-icons/io";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { MdCancel } from "react-icons/md";
import { MdFormatListBulletedAdd } from "react-icons/md";

import { useList } from '../hooks/Request/useList';

import ApiService from "../services/ApiServiceClass";
import { FaCartShopping, FaRegCreditCard, FaTruckFast } from "react-icons/fa6";

const ApproverViewRequest = () => {
    
    const [openModal, setOpenModal] = useState(false);
    const [changeRequestID, setChangeRequestID]  = useState(0);
    const [newStatus, setNewStatus] = useState("New");
    const [remarks, setRemarks] = useState("");
    const [requestStatus, setRequestStatus] = useState(""); 
    
    const [searchParams] = useSearchParams();
    const [dataRequest, setDataRequest] = useState({ status: "", category: "", category_type: "", is_health_safety_risk: "", health_safety_details: "", title: "", description: "", items: [], members: [], total_cost: 0 });
    const [totalCost, setTotalCost] = useState(0);
    
    const helperUtils = useUtils();
    const requestList = useList();

    const requestIDFromParam = searchParams.get("id");
    const request_id_from_param: number = requestIDFromParam !== null && requestIDFromParam !== undefined ? parseInt(requestIDFromParam) : 0;

    const loader = useLoader();
    const auth = useAuth();
    const navigate = useNavigate();

    const { fetchRequestsDetailsByID } = useGetRequestDetailsByID(request_id_from_param);
    const { itemsByRequestID, setItemsByRequestID, fetchItems } = useGetItemsByRequestID(request_id_from_param);

    let numCount = 1;

    const computeTotalCost = () => {
        const totalPriceTemp = itemsByRequestID.reduce((acc: any, currentItem: any) => { 

            const totalAmount = acc + currentItem.price_nzd;

            return totalAmount;
        }, 0);
        setTotalCost(totalPriceTemp)
    }

    const handleChangeStatus = () => {
        const formData = new FormData();
        formData.append('requestID', changeRequestID.toString());
        formData.append('newstatus', newStatus);
        formData.append('remarks', remarks);

        loader?.setIsLoading(true);
        try {
                ApiService.changeRequestStatus(formData)
                .then(() => {
                    requestList?.fetchList();
                    loader?.setIsLoading(false);
                    setOpenModal(false);
                })
                .catch((error) => {
                    console.log(error);
                });
                navigate("/");
        } catch(error) {
            loader?.setIsLoading(false);
            navigate("/login");
        }
    }

    const handleRemarksInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setRemarks(e.target.value);
    }

    const handleChangeToWaitlist = (id: number) => {
        setChangeRequestID(id);
        setNewStatus("Waitlisted");
        setRemarks("");
        setOpenModal(true);
    }

    const handleCustomChangeStatus = (id: number, status: string) => {
        setChangeRequestID(id);
        setNewStatus(status);
        setRemarks("");
        setOpenModal(true);
    }
  
    const handleChangeToApprove = (id: number) => {
      setChangeRequestID(id);
      setNewStatus("Approved");
      setOpenModal(true);
    }
  
    const handleChangeToDissapprove = (id: number) => {
        setChangeRequestID(id);
        setNewStatus("Declined");
        setRemarks("");
        setOpenModal(true);
    }

    const pageCallToAction = () => {        
        return (
            <>
                { ((dataRequest.status === "Waitlisted") || (dataRequest.status === "New")) &&
                    <Button size="xs" className="px-4" onClick={() => handleChangeToApprove(request_id_from_param)}><IoMdCheckmarkCircle className='text-xl mr-1'/> Approve</Button>
                }
                { ((dataRequest.status === "Waitlisted") || (dataRequest.status === "New")) &&
                    <Button size="xs" className="px-12" onClick={() => handleChangeToDissapprove(request_id_from_param)}><MdCancel className='text-xl mr-1'/> Dissapprove</Button>    
                }
                { (dataRequest.status === "New") &&
                    <Button size="xs" className="px-4" onClick={() => handleChangeToWaitlist(request_id_from_param)}><MdFormatListBulletedAdd className='text-xl mr-1'/>Waitlist</Button>
                }
                { (dataRequest.status === "Approved") &&
                    <Button size="xs" className="px-4" onClick={() => handleCustomChangeStatus(request_id_from_param, "Ordered")}><FaCartShopping className='text-xl mr-1'/>Order</Button>
                }
                { ((dataRequest.status === "Approved") || (dataRequest.status === "Ordered")) &&
                    <Button size="xs" className="px-4" onClick={() => handleCustomChangeStatus(request_id_from_param, "Purchased")}><FaRegCreditCard className='text-xl mr-1'/>Purchase</Button>
                }
                { ((dataRequest.status === "Approved") || (dataRequest.status === "Ordered") || (dataRequest.status === "Purchased")) &&
                    <Button size="xs" className="px-4" onClick={() => handleCustomChangeStatus(request_id_from_param, "Delivered")}><FaTruckFast className='text-xl mr-1'/>Deliver</Button>
                }                
            </>
        )
    }



    useEffect(() => {
        if (itemsByRequestID) {
            computeTotalCost();
        }
    }, [itemsByRequestID]);


    useEffect(() => {

        const loadData = async () => {
            try {
                loader?.setIsLoading(true);
                const requestData = await fetchRequestsDetailsByID();
                setDataRequest(requestData);
                const itemsDO = await fetchItems();
                setRequestStatus(requestData.status);
            } catch (error) {
                console.error(error);
            } finally {
                loader?.setIsLoading(false);
            }
        }

        loadData();

    }, []);
    return (
        <>
            <PageTitle title="OPS | New Request" />
            <MainLayout>
                <div className="col-span-12 rounded-sm border border-stroke bg-white px-5 pt-7.5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 ">
                    <h5 className="text-xl font-semibold text-black dark:text-white mb-5">
                        Request Details
                    </h5>
                    <div className="relative z-0 w-full mb-5 group">
                            <div className="flex flex-row">
                                <div className="mr-2">
                                    Status : 
                                </div>
                                <div>
                                    <StatusLabel statusLabel={requestStatus} />        
                                </div>
                            </div>                            
                        </div>
                    <div className="flex justify-between items-center">
                        <div className="grid grid-cols-3 gap-2">
                            { pageCallToAction() }
                        </div>
                        <Comments requestID={request_id_from_param} />
                    </div>
                    <div>
                        <ViewMembersField
                            itemNumber={numCount}
                            labelName='List of Names.'
                            requestMember={dataRequest?.members}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Request Type'
                            value={dataRequest.category_type}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Request Category'
                            value={dataRequest.category}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Title'
                            value={dataRequest.title}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Description'
                            value={dataRequest.description}
                        />
                    </div>
                    <div>
                        <ViewItemField
                            itemNumber={numCount = numCount + 1}
                            labelName='Itemized list of parts with specifications or model numbers requested. Maximum OPEX cost for each IT part is NZ$1000 ex. GST or NZ$5000 ex. GST for each NON-IT part.'
                            requestItem={dataRequest.items}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Are the items requested in any way restricted by law or (University) rules and regulations? Do they pose any health, safety or wellbeing (HSW) risks? If yes, please explain in detail how these issues will be addressed and by whom?'
                            value={dataRequest.is_health_safety_risk}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Health & Safety Details'
                            value={dataRequest.health_safety_details}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Total cost in NZD calculated from the above items.'
                            value={helperUtils.convertToMoney(totalCost) + " NZD"}
                        />
                    </div>
                </div>

                <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} theme={CustomThemeModal} popup>
                    <Modal.Body>
                    <div className="text-center">
                        {/* <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200 mt-3" /> */}
                        <h3 className="mt-5 mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        Are you sure you want to update the request with ID #{changeRequestID} to <StatusLabel statusLabel={newStatus} /> status?
                        </h3>
                        { (newStatus === "Waitlisted" || newStatus === "Declined") && (
                        <div className="mb-5">
                            <div className="mb-2 block text-left">
                            <Label htmlFor="comment" value="Add Remarks to Email" />
                            </div>
                            <Textarea rows={4} value={remarks} onChange={handleRemarksInputChange} />
                        </div>
                        ) }
                        <div className="flex justify-center gap-4">
                        <Button color="success" onClick={() => handleChangeStatus()}>
                            {"Yes, I'm sure"}
                        </Button>
                        <Button color="gray" onClick={() => setOpenModal(false)}>
                            No, cancel
                        </Button>
                        </div>
                    </div>
                    </Modal.Body>
                </Modal>

            </MainLayout>
        </>
    )
}

export default ApproverViewRequest;